import React from "react";
import "./App.css";
import { Link, Redirect } from "react-router-dom";
import Axios from "axios";
import Footer from "./components/Footer";
import ClipLoader from "react-spinners/ClipLoader";
import {
  IoIosContact,
  IoIosCalendar,
  IoIosBarcode,
  IoIosCard,
  IoMdHeartEmpty,
  IoMdPerson,
  IoIosLock,
  IoIosPaper,
  IoIosInformationCircleOutline,
  IoIosLogOut,
  IoIosRemoveCircleOutline,
  IoIosCheckmarkCircleOutline,
  IoIosArrowBack,
} from "react-icons/io";
import { RiEditLine } from "react-icons/ri";
import Header2 from "./components/Header2";
import Header3 from "./components/Header3";
import Header5 from "./components/Header5";
import { BiMenu } from "react-icons/bi";
import SideNavCust from "./layouts/SideNavCust";
import Header from "./layouts/Header";
import SideNav from "./layouts/SideNav";
import SideNavAff from "./layouts/SideNavAff";

class Editprofile extends React.Component {
  constructor(props) {
    super(props);
    const isMobile = window.innerWidth <= 768;
    this.state = {
      query: "",
      password: "",
      response: "",
      error: "",
      successError: "",
      errorDisplay: "none",
      accountname: "",
      phone: "",
      email: "",
      facebook: "",
      twitter: "",
      instagram: "",
      linkedin: "",
      tiktok: "",
      address: "",
      spinning: "none",
      updateDisplay: "block",
      updated_at: "",
      loggedAccountType: "",
      isMobile,
      collapsed: isMobile,
    };
  }

  componentDidMount() {
    this.updateIsMobile();
    window.addEventListener("resize", this.updateIsMobile);

    // alert(localStorage.getItem("partnername"));
    if (localStorage.getItem("customername") !== null) {
      const customername = localStorage.getItem("customername");
      const customerid = localStorage.getItem("customerid");
      document.title = "Edit profile - " + customername + " - Customer";

      Axios.get(
        "https://karamale.com/apps/kscanner/webservices.php?query=CUSTOMERDETAILS&accountid=" +
          customerid,
        {
          withCredentials: true,
        }
      )
        .then((response) => {
          this.setState({
            accountname: response.data.customername,
            phone: response.data.phone,
            email: response.data.email,
            dtregistered: response.data.dtregistered,
            updated_at: response.data.updated_at,
            loggedAccountType: response.data.loggedAccountType,
          });
        })
        .catch(function (error) {
          alert(error);
        });
    } else if (localStorage.getItem("businessname") !== null) {
      const businessname = localStorage.getItem("businessname");
      const businessid = localStorage.getItem("businessid");
      document.title = "Edit profile - " + businessname + " - Business";

      Axios.get(
        "https://karamale.com/apps/kscanner/webservices.php?query=BUSINESSDETAILS&accountid=" +
          businessid,
        {
          withCredentials: true,
        }
      )
        .then((response) => {
          this.setState({
            accountname: response.data.businessname,
            phone: response.data.phone,
            email: response.data.email,
            dtregistered: response.data.dtregistered,
            facebook: response.data.facebook,
            twitter: response.data.twitter,
            instagram: response.data.instagram,
            linkedin: response.data.linkedin,
            tiktok: response.data.tiktok,
            address: response.data.address,
            updated_at: response.data.updated_at,
            loggedAccountType: response.data.loggedAccountType,
          });
        })
        .catch(function (error) {
          alert(error);
        });
    } else {
      const partnername = localStorage.getItem("partnername");
      const partnerid = localStorage.getItem("partnerid");
      document.title = "Edit profile - " + partnername + " - Sales partner";

      Axios.get(
        "https://karamale.com/apps/kscanner/webservices.php?query=PARTNERDETAILS&partnerid=" +
          partnerid,
        {
          withCredentials: true,
        }
      )
        .then((response) => {
          this.setState({
            accountname: response.data.partnername,
            phone: response.data.phone,
            email: response.data.email,
            dtregistered: response.data.dtregistered,
            updated_at: response.data.updated_at,
            facebook: response.data.facebook,
            twitter: response.data.twitter,
            instagram: response.data.instagram,
            linkedin: response.data.linkedin,
            tiktok: response.data.tiktok,
            loggedAccountType: response.data.loggedAccountType,
          });
        })
        .catch(function (error) {
          alert(error);
        });
    }
  }

  handleCustomername = (event) => {
    this.setState({
      accountname: event.target.value,
      errorDisplay: "none",
    });
  };

  handleEmail = (event) => {
    this.setState({
      email: event.target.value,
      errorDisplay: "none",
    });
  };

  handlePhone = (event) => {
    this.setState({
      phone: event.target.value,
      errorDisplay: "none",
    });
  };

  handleFacebook = (event) => {
    this.setState({
      facebook: event.target.value,
      errorDisplay: "none",
    });
  };

  handleTwitter = (event) => {
    this.setState({
      twitter: event.target.value,
      errorDisplay: "none",
    });
  };

  handleInstagram = (event) => {
    this.setState({
      instagram: event.target.value,
      errorDisplay: "none",
    });
  };

  handleLinkedin = (event) => {
    this.setState({
      linkedin: event.target.value,
      errorDisplay: "none",
    });
  };

  handleTiktok = (event) => {
    this.setState({
      tiktok: event.target.value,
      errorDisplay: "none",
    });
  };

  handleAddress = (event) => {
    this.setState({
      address: event.target.value,
      errorDisplay: "none",
    });
  };

  update = () => {
    let accountid = 0;
    this.setState({ updateDisplay: "none", spinning: "block" });
    const accounttype = localStorage.getItem("accounttype");
    const phone = this.state.phone;
    const email = this.state.email;

    if (
      this.state.accountname.trim() == "" ||
      this.state.email.trim() == "" ||
      this.state.phone == ""
    ) {
      this.setState({ updateDisplay: "block", spinning: "none" });
      this.setState({
        error: "All fields are required",
        errorDisplay: "block",
        successError: "error-login",
      });
    } else {
      const baseURL = "https://karamale.com/apps/kscanner/webservices.php";
      const data = new FormData();
      data.append("accountname", this.state.accountname);
      data.append("phone", this.state.phone);
      data.append("email", this.state.email);
      data.append("facebook", this.state.facebook);
      data.append("twitter", this.state.twitter);
      data.append("instagram", this.state.instagram);
      data.append("linkedin", this.state.linkedin);
      data.append("tiktok", this.state.tiktok);
      data.append("address", this.state.address);
      data.append("query", "EDITACCOUNTDETAILS");
      Axios({
        method: "POST",
        url: baseURL,
        data: data,
        withCredentials: true,
      })
        .then((response) => {
          this.setState({ updateDisplay: "block", spinning: "none" });
          let assignClass = "";
          if (response.data.status === "failed") {
            assignClass = "error-login";
          } else {
            assignClass = "success-login";
          }
          this.setState({
            error: response.data.message,
            errorDisplay: "block",
            successError: assignClass,
          });

          setTimeout(() => {
            this.setState({ errorDisplay: "none" });
          }, 4000);
        })
        .catch(function (error) {
          console.log(error);
          // this.setState({
          //   error: error,
          //   errorDisplay: "block",
          //   successError: "error-login",
          // });

          setTimeout(() => {
            this.setState({ errorDisplay: "none" });
          }, 4000);
        });
    }
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateIsMobile);
  }

  updateIsMobile = () => {
    const isMobile = window.innerWidth <= 768;
    this.setState((prev) => ({
      isMobile,
      collapsed: isMobile ? true : prev.collapsed, // auto-collapse only when entering mobile
    }));
  };

  handleToggle = () => {
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed,
    }));
  };

  render() {
    let { accountname, dashboard } = "";
    if (localStorage.getItem("customername") === null) {
      if (localStorage.getItem("businessname") === null) {
        if (localStorage.getItem("partnername") === null) {
          return <Redirect to="/login" />;
        } else {
          accountname = localStorage.getItem("partnername");
          dashboard = "in";
        }
      } else {
        accountname = localStorage.getItem("businessname");
        dashboard = "dashboard";
      }
    } else {
      accountname = localStorage.getItem("customername");
      dashboard = "customerdashboard";
    }
    const customername = accountname;
    const dtregistered = this.props.location.state.dtregistered;

    const accounttype = localStorage.getItem("accounttype");

    const { collapsed, isMobile } = this.state;
    return (
      <div className="view">
        <Header />
        {accounttype === "customer" ? (
          <>
            <SideNavCust
              collapsed={this.state.collapsed}
              onToggle={this.handleToggle}
            />
          </>
        ) : accounttype === "business" ? (
          <>
            <SideNav
              collapsed={this.state.collapsed}
              onToggle={this.handleToggle}
            />
          </>
        ) : (
          <SideNavAff
            collapsed={this.state.collapsed}
            onToggle={this.handleToggle}
          />
        )}
        <div
          className="container"
          style={{
            marginTop: 40,
            marginLeft: this.state.isMobile
              ? "0px"
              : this.state.collapsed
              ? "auto"
              : "auto",
          }}
        >
          {/* ✅ Mobile overlay when sidebar is open */}
          {isMobile && !collapsed && (
            <div
              className="mobile-overlay active"
              onClick={this.handleToggle}
            />
          )}

          {this.state.isMobile && this.state.collapsed && (
            <label className="mobile-toggle" onClick={this.handleToggle}>
              <BiMenu size={25} />
            </label>
          )}
          <div className="row justify-content-center just-container-insid">
            <div className="col-lg-7 pl-0 pr-0">
              <div className=" BoxDashboardContainer mt-5 mb-4 mrgin-search pl-0 pr-0">
                <div className="row align-self-center justify-content-center">
                  <div className="item-list p-0">
                    <div className="col-12 pl-0">
                      <button
                        onClick={() => this.props.history.goBack()}
                        className="link-btn"
                      >
                        <IoIosArrowBack size={25} />
                        Back &nbsp;
                      </button>
                    </div>

                    {/* <div className="col-lg-8 col-6 text-right">
                      <label className="back-arrow mb-0">
                        <div className="save-btn" onClick={() => this.update()}>
                          <span
                            style={{
                              display: this.state.updateDisplay,
                            }}
                          >
                            {" "}
                            Update
                          </span>
                          <span
                            style={{
                              display: this.state.spinning,
                            }}
                          >
                            <ClipLoader
                              color={"#fff"}
                              loading={true}
                              // css={override}
                              size={20}
                            />
                          </span>
                        </div>
                      </label>
                    </div> */}
                  </div>
                </div>
              </div>

              <div className=" BoxDashboardContainer mb-4 pl-0 pr-0">
                <div className="row align-self-center justify-content-center">
                  <div className="item-list p-0">
                    <div className="col-lg-12 pl-0">
                      <label className="ticket-title pl-0 pr-0">
                        EDITING PROFILE{" "}
                      </label>
                    </div>
                  </div>

                  <div className="h-divider w-100"></div>
                </div>
                <div className="col-lg-12 details-body">
                  <span>Details</span>
                  <br />
                  <br />
                  {localStorage.getItem("customername")
                    ? "Name and surname"
                    : localStorage.getItem("businessname")
                    ? "Business name"
                    : "Name and surname"}
                  <br />
                  <input
                    type="text"
                    placeholder={
                      localStorage.getItem("customername")
                        ? "Name and surname"
                        : "Business name"
                    }
                    value={this.state.accountname}
                    onChange={this.handleCustomername}
                    className="edit-input"
                  />
                  <br /> <br />
                  Email
                  <br />
                  <input
                    type="email"
                    placeholder="Email address"
                    value={this.state.email}
                    onChange={this.handleEmail}
                    className="edit-input"
                  />
                  <br /> <br />
                  Phone number
                  <br />
                  <input
                    type="text"
                    placeholder="Phone number"
                    value={this.state.phone}
                    onChange={this.handlePhone}
                    className="edit-input"
                  />
                  {/* <br />
                  <br />
                  Account created
                  <br />
                  <label className="small-details">{dtregistered}</label>
                  <br />
                  <br />
                  Updated on
                  <br />
                  <label className="small-details">
                    {this.state.updated_at}
                  </label> */}
                  <label
                    className={`${
                      !localStorage.getItem("customername")
                        ? "d-none"
                        : "back-arrow mb-0 bottom__button mt-3"
                    }`}
                  >
                    <button
                      type="button"
                      disabled={this.state.spinning === "block" ? true : false}
                      className={`${
                        this.state.spinning === "block"
                          ? "btn-disabled"
                          : "save-btn"
                      } float-right`}
                      onClick={() => this.update()}
                    >
                      <span
                        style={{
                          display: this.state.updateDisplay,
                        }}
                      >
                        Update
                      </span>
                      <span
                        style={{
                          display: this.state.spinning,
                        }}
                      >
                        <ClipLoader
                          color={"grey"}
                          loading={true}
                          // css={override}
                          size={20}
                        />
                      </span>
                    </button>
                  </label>
                </div>
              </div>

              {localStorage.getItem("customername") ? (
                ""
              ) : (
                <div className=" BoxDashboardContainer mb-5 pl-0 pr-0">
                  <div className="row align-self-center justify-content-center">
                    <div className="item-list p-0">
                      <div className="col-lg-12 pl-0">
                        <label className="ticket-title pl-0 pr-0">
                          EDITING SOCIAL ACCOUNTS
                          <br />
                          <span className="color-grey text-12 font-normal">
                            Make it easy for your attendees to find you
                          </span>
                        </label>
                      </div>
                    </div>

                    <div className="h-divider w-100"></div>
                  </div>
                  <div className="col-lg-12 details-body">
                    <span>Details</span>
                    <br />
                    <br />
                    Facebook profile URL
                    <br />
                    <input
                      type="text"
                      placeholder="https://facebook.com/username"
                      value={this.state.facebook}
                      onChange={this.handleFacebook}
                      className="edit-input"
                    />
                    <br /> <br />
                    X handle
                    <br />
                    <input
                      type="text"
                      placeholder="https://x.com/username"
                      value={this.state.twitter}
                      onChange={this.handleTwitter}
                      className="edit-input"
                    />
                    <br /> <br />
                    Instagram handle
                    <br />
                    <input
                      type="text"
                      placeholder="https://instagram.com/username"
                      value={this.state.instagram}
                      onChange={this.handleInstagram}
                      className="edit-input mb-1"
                    />
                    <br /> <br />
                    Linkedin profile URL
                    <br />
                    <input
                      type="text"
                      placeholder="https://linkedin.com/in/username"
                      value={this.state.linkedin}
                      onChange={this.handleLinkedin}
                      className="edit-input mb-1"
                    />
                    <br /> <br />
                    Tiktok handle
                    <br />
                    <input
                      type="text"
                      placeholder="https://www.tiktok.com/username"
                      value={this.state.tiktok}
                      onChange={this.handleTiktok}
                      className="edit-input mb-3"
                    />
                    {this.state.loggedAccountType !== "business" ? (
                      ""
                    ) : (
                      <>
                        <br />
                        Business address
                        <br />
                        <textarea
                          value={
                            this.state.address == "null" ||
                            this.state.address == null
                              ? ""
                              : this.state.address
                          }
                          onChange={this.handleAddress}
                          placeholder="Address"
                          className="edit-input mt-0"
                        />
                      </>
                    )}
                    <label className="back-arrow mb-0 bottom__button">
                      <button
                        type="button"
                        disabled={
                          this.state.spinning === "block" ? true : false
                        }
                        className={`${
                          this.state.spinning === "block"
                            ? "btn-disabled"
                            : "save-btn"
                        } float-right`}
                        onClick={() => this.update()}
                      >
                        <span
                          style={{
                            display: this.state.updateDisplay,
                          }}
                        >
                          Update
                        </span>
                        <span
                          style={{
                            display: this.state.spinning,
                          }}
                        >
                          <ClipLoader
                            color={"grey"}
                            loading={true}
                            // css={override}
                            size={20}
                          />
                        </span>
                      </button>
                    </label>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div
          className={this.state.successError}
          style={{ display: this.state.errorDisplay, textAlign: "center" }}
        >
          {this.state.error}
        </div>
        {/* <Footer /> */}
      </div>
    );
  }
}

export default Editprofile;
